import React, { ImgHTMLAttributes } from 'react'

import rqCertifiedLogo from '@/components/misc/RqCertifiedLogo/rq-certified-logo.svg'
import { cn } from '@/lib/utils'

type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'>

const RqCertifiedLogo: React.FC<Props> = ({
  alt = 'RQ Certified',
  className,
  style,
  ...props
}) => (
  <img
    {...props}
    alt={alt}
    src={rqCertifiedLogo}
    className={cn('max-w-full', className)}
    style={{ maxWidth: '100px', ...style }}
  />
)

export default RqCertifiedLogo
